<template>
  <div class="serve-header-warp">
    <div class="serve-header-warp">
      <div class="tabs-warp">
        <span class="tabs-item" :class="activeId == item.id ? 'is-active' : ''" v-for="item in tabList" :key="item.id" @click="handleClick(item)">{{item.label}}</span>
      </div>
    </div>
    <slot></slot>
    <div class="serve-layout-btn">
      <span @click="doClick" class="simulation-btn">查看更多 ></span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabList: {
      type: Array,
      default: () => []
    },
    value: [String, Number]
  },
  watch: {
    value: {
      handler: function(val) {
        this.activeId = val
      },
      immediate: true
    }
  },
  data() {
    return {
      activeId: '',
    }
  },
  methods: {
    handleClick(item) {
      console.log(item);
      this.activeId = item.id
      this.$emit('input', item.id)
      this.$emit('click', item.id)
    },
    btnClick() {
      this.$emit('btn-click')
    },
    doClick() {
      this.$emit('do-click')
    }
  }
}
</script>

<style lang='less' scoped>
  .serve-header-warp {
    width: 100%;
    .serve-header-warp {
      width: 100%;
      height: 55px;
      text-align: center;
      border-bottom: 1px solid #E8E8E8;
      .tabs-warp {
        height: 55px;
        width: 100%;
        display: flex;
        justify-content: left;
        .tabs-item {
          font-size: 26px;
          font-weight: 600;
          color: #808080;
          margin-right: 50px;
          position: relative;
          cursor: pointer;
        }
        .tabs-item:last-child {
          margin-right: 0;
        }
        .is-active {
          color: #333333;
        }
        .is-active::before {
          content: '';
          position: absolute;
          width: 50px;
          height: 3px;
          background: #2557B2;
          border-radius: 2px;
          bottom: 0;
          left: calc(50% - 25px);
        }
      }
    }
    .serve-layout-btn {
      width: 100%;
      text-align: center;
      .simulation-btn {
        display: inline-block;
        cursor: pointer;
        width: 90px;
        height: 30px;
        line-height: 30px;
        border-radius: 2px;
        border: 1px solid #3585FF;
        color: #3585FF;
        font-size: 14px;
        // font-weight: 600;
      }
    }
  }
</style>